import classNames from 'classnames';
import { utils } from "../../../utils";
import BottomArea from "./BottomArea";
import { makeSectionsFromServices } from "./makeSectionsFromServices";
import PackageCard from "./PackageCard";
import styles from "./PackageSelector.module.scss";
import ServiceItem from "./ServiceItem";
import ServicesSection from "./ServicesSection";
import { jsx as _jsx } from "react/jsx-runtime";
const sectionTitle = (id, sum) => {
  if (id === 'optional') {
    return 'Optional services';
  } else if (id === 'variable') {
    return 'Variable';
  } else if (sum != null) {
    return utils.formatDollarAmount(sum);
  }
};
export default function PackageSelector(_ref) {
  let {
    packages,
    selectedBundleID,
    isMobile = false,
    onSelect
  } = _ref;
  return /*#__PURE__*/_jsx("ul", {
    className: classNames(styles.packagesList, {
      [styles.mobile]: isMobile
    }),
    children: packages.map((_ref2, idx) => {
      let {
        id,
        name,
        services
      } = _ref2;
      const bundleTestPrefix = "package-".concat(id);
      return /*#__PURE__*/_jsx(PackageCard, {
        id: id,
        name: name,
        "data-testid": "package-card-".concat(idx),
        bottomArea: /*#__PURE__*/_jsx(BottomArea, {
          selected: id === selectedBundleID,
          "data-testid": bundleTestPrefix,
          onClick: () => onSelect(id)
        }),
        children: makeSectionsFromServices(services).map(_ref3 => {
          let {
            id,
            services,
            category,
            subtitle,
            sum,
            hasOptionalServices,
            id: sectionID
          } = _ref3;
          return /*#__PURE__*/_jsx(ServicesSection, {
            hasOptionalServices: hasOptionalServices,
            title: sectionTitle(id, sum),
            subtitle: subtitle,
            category: category,
            "data-testid": "".concat(bundleTestPrefix, "-section-").concat(sectionID),
            children: services.map(_ref4 => {
              let {
                id: serviceID,
                name,
                description,
                variablePriceText,
                includedServices
              } = _ref4;
              return /*#__PURE__*/_jsx(ServiceItem, {
                name: name,
                description: description,
                includedServices: includedServices,
                variablePriceText: variablePriceText,
                testId: "".concat(bundleTestPrefix, "-service-").concat(serviceID)
              }, serviceID);
            })
          }, sectionID);
        })
      }, id);
    })
  });
}